import rewardIcon from '../../assets/icons/clock.png';
import particleIcon from '../../assets/icons/particle.png';
import { useNavigate } from 'react-router';

function PlaygroundRouteCard() {
  const navigate = useNavigate();

  return (
    <div className="flex w-full">
      <div
        className="relative h-24 w-full cursor-pointer overflow-hidden rounded-[10px] bg-white shadow-[0px_5px_16px_0px_rgba(0,0,0,0.09)]"
        onClick={() => navigate('/time-nyang')}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            navigate('/time-nyang');
          }
        }}
        aria-label="타임냥 이동"
      >
        <div className="absolute right-2 top-[4px] h-[78.5px] w-[170px]">
          <img src={particleIcon} alt="" className="h-[78.5px] w-[170px]" />
        </div>

        <img src={rewardIcon} alt="보상 아이콘" className="absolute right-[25px] top-[24px] h-[72px] w-[82px]" />

        <div className="absolute left-[22px] top-[18.5px] text-sm font-extrabold text-[#8E8F99] font-['Pretendard']">
          오늘 가장 빠른 루트 추천
        </div>

        <div className="absolute left-[22px] top-[42px] inline-flex items-center gap-2.5">
          <div className="inline-flex flex-col items-start justify-start">
            <div className="text-2xl font-extrabold text-black font-['Pretendard']">타임냥</div>
          </div>

            <div className="h-9 px-5 py-1.5 bg-background01 rounded-[20px] inline-flex justify-center items-center gap-2.5">
              <div className="flex item-center justify-center">
                <span className="text-gray03 text-sm font-medium font-['Pretendard']">한방에 </span>
                <span className="ml-1 text-sm font-extrabold text-primary-purple-01 font-['Pretendard']">400p</span>
              </div>
            </div>
        </div>
      </div>
    </div>
  );
}

export default PlaygroundRouteCard;
